import { ConciergeItemPage } from '@/lib/pages/concierge/ConciergeItemPage';
import {
  getConciergeItemStaticPaths,
  getConciergeItemStaticProps,
} from '@/lib/pages/concierge/get-item-static-props';

export default ConciergeItemPage;

export const getStaticPaths = getConciergeItemStaticPaths('yacht');
export const getStaticProps = getConciergeItemStaticProps('yacht');
